import type { FC } from 'react';
import type { LineProps } from './index';

export const BoldCircleLine: FC<LineProps> = ({ color, width, height }) => {
    return (
        <svg width={width} height="8" viewBox="0 0 90 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 4L14 4" stroke={color} strokeWidth={height} />
            <path d="M20 4L28 4" stroke={color} strokeWidth={height} />
            <path d="M34 4L42 4" stroke={color} strokeWidth={height} />
            <path d="M48 4L56 4" stroke={color} strokeWidth={height} />
            <path d="M62 4L71 4" stroke={color} strokeWidth={height} />
            <path d="M62 4L70 4" stroke={color} strokeWidth={height} />
            <path d="M76 4L84 4" stroke={color} strokeWidth={height} />
            <circle cx="3" cy="4" r="2.5" stroke={color} strokeWidth={height} />
            <circle cx="17" cy="4" r="2.5" stroke={color} strokeWidth={height} />
            <circle cx="31" cy="4" r="2.5" stroke={color} strokeWidth={height} />
            <circle cx="45" cy="4" r="2.5" stroke={color} strokeWidth={height} />
            <circle cx="59" cy="4" r="2.5" stroke={color} strokeWidth={height} />
            <circle cx="73" cy="4" r="2.5" stroke={color} strokeWidth={height} />
            <circle cx="87" cy="4" r="2.5" stroke={color} strokeWidth={height} />
        </svg>
    );
};
